import { Component, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { SecuredBaseComponent } from '../base/secured-base.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ResetPassword } from '../models/ResetPassword';
import { ManagerService } from '../services/manager.service';
import { Manager } from '../models/Manager';

@Component({
  selector: 'profile',
  templateUrl: 'profile.component.html',
  styleUrls: ['profile.component.css']
})
export class ProfileComponent extends SecuredBaseComponent {

  @ViewChild('logoUpload') logoUpload!: ElementRef;

  matchPassword: ValidatorFn = (control: AbstractControl): ValidationErrors | null => { 
    return this.passwordFormControl.value === control.value ? null : { notMatch: true }
  }

  nameFormControl = new FormControl('', [Validators.required]);
  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  passwordFormControl = new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*_\?\|\-\+~=\.\,:;\/\(\)\[\]\{\}])(?=.{8,})/)]);
  confPasswordFormControl = new FormControl('', [Validators.required, this.matchPassword]);

  constructor(public override snackBar: MatSnackBar, public override router: Router, public override managerService: ManagerService, private dialog: MatDialog)
  {
    super(snackBar, router, managerService);
  }

  changed: boolean = false;
  resetPassword: ResetPassword = {
    code: environment.resetPasswordCode,
    password: ''
  };
  confirmPassword!: string;
  showPassword: boolean = false;

  override ngOnInit() {
    super.ngOnInit();
    
    this.loadManager();
  }

  loadManager() {
    this.managerService.getMe().subscribe(
      manager => {
        this.manager = manager as Manager;
        this.changed = false;
      },
      error => { this.showError(error, 'Get logged user has failed due to server error'); }
    );
  }

  onChange() {
    this.changed = true;
  }

  formValid() {
    return this.nameFormControl.valid && this.emailFormControl.valid;
  }

  save() {
    if (this.formValid() && this.changed) {
      this.managerService.update(this.manager).subscribe(
        manager => {
          this.manager = manager as Manager;
          this.managerService.setLoggedUser(this.manager);
          this.changed = false;
          this.showSuccess('Successfully saved');
        },
        error => { this.showError(error, 'Save user has failed due to server error'); }
      );
    }
  }

  cancel() {
    if (this.changed) {
      var dialogRef = this.dialog.open(ConfirmDialogComponent, { data: {
        title: 'Unsaved changes',
        message: 'There are unsaved changes and all unsaved changes will be lost. Do you want to continue?'
      }});
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'ok')
          this.loadManager();
      });
    }
  }

  passwordFormValid() {
    return this.passwordFormControl.valid && this.confPasswordFormControl.valid;
  }

  saveChangePassword() {
    if (this.passwordFormValid()) {
      this.managerService.updatePassword(this.manager.id, this.resetPassword).subscribe(
        () =>
        {
          this.cancelChangePassword();
          this.showSuccess('Password has changed successfully');
        },
        error => { this.showError(error, 'Change password has failed due to server error'); }
      );
    }
  }

  cancelChangePassword() {
    this.resetPassword.password = '';
    this.confirmPassword = '';
    this.passwordFormControl.markAsUntouched();
    this.confPasswordFormControl.markAsUntouched();
  }
}
